import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class DeleteButtonModel extends ButtonBase {
    label: string = 'Delete';
    action: string = ACTION_STATUS.delete;
    matIconName: string = 'delete';
    colorClass: string = 'color-primary-500';
}